module.exports = __webpack_public_path__ + "static/media/icon6.9c53a15e.svg";